import { IonText } from "@ionic/react";

import styles from "@components/menus/MenuItemText.module.css";

type Props = {
  selected: boolean;
  text: string;
};

const MenuText = ({ selected, text }: Props) => (
  <IonText className={`${styles.text} no-wrap`} color={selected ? "primary" : "white"}>
    {text}
  </IonText>
);

export default MenuText;
